"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayerSpacesToThousands = void 0;
var modifierToNumber_1 = require("../modifiers/modifierToNumber");
var isTypeString_1 = require("../../typeGuards/isTypeString");
var isTypeNumber_1 = require("../../typeGuards/isTypeNumber");
var displayerSpacesToThousands = function (value) {
    var stringifiedValue = '';
    if (isTypeString_1.isTypeString(value)) {
        var valueToNumber = modifierToNumber_1.modifierToNumber(value);
        if (!isTypeNumber_1.isTypeNumber(valueToNumber) && !isTypeString_1.isTypeString(valueToNumber)) {
            throw new Error("Form: value must be a string or a number");
        }
        if (isTypeNumber_1.isTypeNumber(valueToNumber)) {
            stringifiedValue = (valueToNumber).toString();
        }
    }
    if (isTypeNumber_1.isTypeNumber(value)) {
        stringifiedValue = value.toString();
    }
    var splitValue = stringifiedValue.split('.');
    var modifiedValueInt = splitValue[0] || "";
    var modifiedValueFloat = splitValue[1] || "";
    modifiedValueInt = modifiedValueInt.replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    if (modifiedValueFloat) {
        return modifiedValueInt + "." + modifiedValueFloat;
    }
    return modifiedValueInt;
};
exports.displayerSpacesToThousands = displayerSpacesToThousands;
//# sourceMappingURL=displayerSpacesToThousands.js.map